import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import EquipmentAllotmentCharge from './equipment-allotment-charge';
import EquipmentAllotmentChargeDetail from './equipment-allotment-charge-detail';
import EquipmentAllotmentChargeUpdate from './equipment-allotment-charge-update';
import EquipmentAllotmentChargeDeleteDialog from './equipment-allotment-charge-delete-dialog';

const EquipmentAllotmentChargeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<EquipmentAllotmentCharge />} />
    <Route path="new" element={<EquipmentAllotmentChargeUpdate />} />
    <Route path=":id">
      <Route index element={<EquipmentAllotmentChargeDetail />} />
      <Route path="edit" element={<EquipmentAllotmentChargeUpdate />} />
      <Route path="delete" element={<EquipmentAllotmentChargeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EquipmentAllotmentChargeRoutes;
